import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46')
];

export const server_loads = [];

export const dictionary = {
		"/(practice)": [4,[2]],
		"/about": [18],
		"/(practice)/active-listening": [5,[2]],
		"/admin": [19,[3]],
		"/admin/billing": [20,[3]],
		"/admin/dead-letters": [21,[3]],
		"/admin/deletions": [22,[3]],
		"/admin/impersonate": [23,[3]],
		"/admin/projections": [24,[3]],
		"/admin/users": [25,[3]],
		"/admin/users/[id]": [26,[3]],
		"/(practice)/archetypes": [6,[2]],
		"/billing": [27],
		"/billing/cancel": [28],
		"/billing/success": [29],
		"/(practice)/body-language": [7,[2]],
		"/coffee": [30],
		"/(practice)/dev-focus": [8,[2]],
		"/dev/design-system": [31],
		"/export/[id]": [32],
		"/legal/third-party": [33],
		"/(practice)/library": [9,[2]],
		"/login": [34],
		"/pricing": [35],
		"/privacy": [36],
		"/profile": [37],
		"/(practice)/progress": [10,[2]],
		"/(practice)/progress/plans": [11,[2]],
		"/(practice)/recent-practices": [12,[2]],
		"/recordings/[id]": [38],
		"/recordings/[id]/review": [39],
		"/(practice)/rehearsal": [13,[2]],
		"/(practice)/rehearsal/series": [14,[2]],
		"/(practice)/rehearsal/series/[id]": [15,[2]],
		"/reviews": [41],
		"/reviews/[id]": [42],
		"/review/[id]": [40],
		"/signup": [43],
		"/(practice)/storytelling": [16,[2]],
		"/support": [44],
		"/terms": [45],
		"/unsubscribe/reminders": [46],
		"/(practice)/word-play": [17,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';